import { FilterOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { IconColour } from 'src/general/Icons/IconColour';
import { FilterOptionFieldsGroup } from '../components/Fields/FilterOptionFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterOption>;

export const FilterColour = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'colour';
  const header = <FilterName icon={<IconColour />} label="Colour" showNotificationBadge={showNotificationBadge} />;
  const content = (
    <FilterOptionFieldsGroup
      options={options.map((option) => ({ ...option, label: option.label ?? '' }))}
      currentFilters={currentFilters}
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
